module.exports = __webpack_public_path__ + "static/media/icone-medico.f5b1856b.png";